export const all_routes = {
  dashboard: "/admin-dashboard",
  atualizacoes: "/atualizacoes",
  chartsdashboard: "/charts-dashboard",
  chamados: "/chamados",
  profile: "/profile",
  signin: "/login",
  register: "/registro",
  forgotPassword: "/esqueceu-a-senha",
  resetpassword: "/redefinir-senha",
  emailverification: "/email-verification",
  twostepverification: "/two-step-verification",
  error404: "/error-404",
  error500: "/error-500",
  blankpage: "/blank-page",
  undermaintenance: "/under-maintenance",
  users: "/usuarios",
  selecaoestabelecimento: "/selecao-estabelecimento",
  usuarioacessorelatorio: "/usuario-acesso-relatorio",
  configuracaogrupodeacesso: "/configuracao-grupo-de-acesso",
  unificacaodecadastros: "/unificacao-de-cadastros",
  importacaoorganograma: "/importacao-organograma",
  convocacaorastreamento: "/convocacao-rastreamento",
  convocacaoseguimento: "/convocacao-seguimento",
};
